/**
 * CategoryCards Component
 * Renders feature cards for main Community Trust categories (Sub-Groups, Sports,
 * Community Groups) displaying descriptions, upcoming event count badges, and detail route triggers.
 * @param {Object} props - Component props
 * @param {Array<Object>} props.events - List of trust events used for calculating category badges
 */

import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

function CategoryCards({ events }) {
  const navigate = useNavigate();

  // Helper functions for filtering and counting events per category key
  const categoryEvents = category => events.filter(event => event.category === category);
  const eventCount = category => categoryEvents(category).length;

  const categories = useMemo(() => [
    {
      key: 'community',
      title: 'Our Sub-Groups',
      description: 'Discover the trust’s own social club, friendship groups, cricket team, junior and adult football teams, and bowls group that meet and grow at our institute.',
      hoverTitle: 'Our Sub-Groups',
      hoverDescription: 'Explore the trust-run subgroups that support friendship, sport, and local connection through regular club nights, teams, and community gatherings.',
      route: '/trust/community',
    },
    {
      key: 'sports',
      title: 'Sports Activities',
      description: 'Discover local teams, recreational sports, and facilities available for all ages and abilities.',
      hoverTitle: 'Sports Activities',
      hoverDescription: 'From football to fitness classes, this area covers training, friendly matches and accessible sport programmes for the whole community.',
      route: '/trust/sports',
    },
    {
      key: 'activities',
      title: 'Community Groups and Activities',
      description: 'Learn about external community groups that use our institute for their events and activities, bringing wider neighbours together in shared spaces.',
      hoverTitle: 'Community Groups and Activities',
      hoverDescription: 'Community groups not owned by the trust but welcomed at our institute for events, sessions and gatherings that enrich local life.',
      route: '/trust/activities',
    },
  ], []);

  return (
    <>
      <section className="card-grid">
        {categories.map(category => (
          <article className="feature-card" key={category.key}>
            <div className="card-header-row">
              <h2>{category.title}</h2>
              {eventCount(category.key) > 0 && <span className="event-badge">{eventCount(category.key)} upcoming event{eventCount(category.key) > 1 ? 's' : ''}</span>}
            </div>
            <p>{category.description}</p>
            <div className="card-actions">
              <button className="view-button" onClick={() => navigate(category.route)}>
                View Details
              </button>
            </div>
          </article>
        ))}
      </section>
    </>
  );
}

export default CategoryCards;
